/* LE DUE FASCE SPARISCONO MENTRE SCORRI E TORNANO QUANDO TI FERMI — 02/09/2026
   Matteo: «quando scrollo togli lo sticky, poi il menu riappare 1 secondo dopo che mi
   sono fermato».

   Perche' serve JavaScript e non basta il CSS: «mentre scorri» il CSS lo sa fare
   (animazioni legate allo scroll), «un secondo dopo che ti sei fermato» no — quello e'
   un tempo, e il tempo il CSS non lo misura. Qui c'e' solo il cronometro: il movimento
   e la misura stanno in `custom-tavola.css`, sulla classe `mb-testa--via`.

   DUE FASCE, NON UNA (Matteo, stessa sera): «e se la barra scorrevole la mettiamo in
   fondo allo schermo e anche quella appare quando si ferma lo scroll». Quindi il menu
   sale e sparisce in alto, la barra annunci scende e sparisce in basso, e tornano
   insieme. La barra annunci ci guadagna due volte: prima scorreva via all'inizio della
   pagina e non tornava piu', adesso resta a portata di pollice per tutta la visita.

   Sta nel gruppo footer (sezione `mb_card_tavola`, quella che carica anche il CSS):
   e' l'unico aggancio nostro che vive su TUTTE le pagine senza toccare `theme.liquid`.

   ⚠️ SOLO SUL TELEFONO. Sul desktop l'intestazione resta ferma dov'e': li' non ruba
   schermo e sparire mentre si scorre col mouse da' fastidio invece che sollievo.
   ⚠️ In cima alla pagina non sparisce mai: sopra i primi pixel non c'e' niente da
   guadagnare e un'intestazione che si nasconde da ferma sembra un errore. */
(() => {
  const testa = document.querySelector('header.site-header');
  /* si muove la SEZIONE, non l'`header`: e' la sezione ad avere `position:sticky`,
     ed e' quella che resta incollata in cima. Muovere il figlio non sposta il padre. */
  const fasce = [
    testa && (testa.closest('[id^="shopify-section-"]') || testa),
    document.querySelector('[id^="shopify-section-"][id*="scrolling_banner"]'),
  ].filter(Boolean);
  if (!fasce.length) return;
  const telefono = matchMedia('(max-width: 900px)');
  const ATTESA = 150;           // 28/09 Matteo: «riappare quando lo scroll finisce, cosi' si sa subito
                                // dove andare». Era 1000 (02/09): sul telefono si sommava allo scivolamento
                                // dopo il dito, e il menu tornava dopo 2-3 s. Mentre la pagina scivola
                                // arriva uno scroll a ogni fotogramma (~16 ms): 150 ms di silenzio = ferma.
  const CIMA = 8;               // sotto questi pixel siamo «in cima» e non si nasconde
  let timer = null, via = false;

  const mostra = () => { if (!via) return; fasce.forEach(f => f.classList.remove('mb-testa--via')); via = false; };
  const nascondi = () => { if (via) return; fasce.forEach(f => f.classList.add('mb-testa--via')); via = true; };

  const alloScroll = () => {
    if (!telefono.matches) { clearTimeout(timer); mostra(); return; }
    if (window.scrollY <= CIMA) { clearTimeout(timer); mostra(); return; }
    nascondi();
    clearTimeout(timer);
    timer = setTimeout(mostra, ATTESA);
  };

  addEventListener('scroll', alloScroll, { passive: true });
  /* girando il telefono o allargando la finestra si torna sempre a intestazione visibile:
     se no si resta con la barra nascosta e nessuno scroll che la faccia tornare */
  telefono.addEventListener('change', () => { clearTimeout(timer); mostra(); });
})();
